/** One label-and-amount line of the review money card. */
export default function Row({
  label,
  value,
  tone,
}: {
  label: string;
  value: string;
  tone?: string;
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, fontSize: 12.5 }}>
      <span style={{ flex: 1, color: 'var(--nb-muted)' }}>{label}</span>
      <span className="nb-tabular" style={{ fontWeight: 700, color: tone ?? 'var(--nb-ink)' }}>
        {value}
      </span>
    </div>
  );
}
